module.exports = __webpack_public_path__ + "img/r11.6bd3c2e7.jpg";